import * as catalogos from './catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB': 'Saving changes...',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG': 'Questions',
      'TITULO_TAB_TRAD': 'Translation',
      'TITULO_TAB_PREV': 'Preview',
      'TAB_PREGUNTAS':{
        'CLA':'Key:',
        'BTN_CONFIG_PLA': 'Template configuration',
        'SLI_VER_US_EMPRE': 'View as a business user',
        'ETI_INSTNES': 'You can load a list of questions contained in a template, following these steps:',
        'ETI_INST1': 'Download the template',
        'ETI_INST2': 'Fill in the template with the questions according to the format',
        'ETI_INST3': 'Load the template with the questions',
        'ETI_INST_NOT': 'Note: you can upload a list of questions in a general way or within each available section',
        'ETI_SECCI_NOT_GRU': 'This section has no group',
        'INST_AGRE_GRUP': 'Add a group of questions with the following button',
        'BTN_AGRE_GRUP': 'Add a group',
        'INST2_AGRE_GRUP': 'You can add questions to this group later',
        'ETI_DETEC_CAMB_PLAN': 'Changes were detected in the original template',
        'BTN_GUAR_CAMB': 'Save changes',
        'BTN_GUAR_CAMB_NEW_PLAN': 'Save as new template',
        'MAT_DESC_PLAN': 'Download template',
        'ETI_LIS_GRUP': 'Group list',
        'MAT_CHIP_PRE_EXTR_SI': 'Extra questions available: ',
        'MAT_CHIP_PRE_EXTR_NO': 'You can no longer add extra questions',
        'MAT_CHIP_PRE_EXTR_ILIM': 'Unlimited extra questions',
        'ETI_INST_COLO_CUR': 'Place the cursor over any group to see the available actions',
        'MAT_EDIT_NOMB_SECC': 'Edit the name of the group',
        'MAT_DELET_SECC': 'Remove this group',
        'MAT_AGRE_SECC_ARRI': 'Add a group above',
        'ETI_SECC_SIN_PREG': 'This group has no questions',
        'ETI_SECC_INST_COLO_CUR': 'Place the cursor over a question to see the available actions',
        'ETI_PREG_OPCIO_EDITA': 'Optional editable question',
        'ETI_PREG_OPCIO_NO_EDITA': 'Optional non-editable question',
        'ETI_PREG_OPCIO_OBLI_EDITA': 'Mandatory editable question',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA': 'Mandatory non-editable question',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'Required question answer',
        'MAT_FALT_OPC_RESP': 'Response options missing',
        'ETI_FALT_OPC_RESP': 'Question missing answer options',
        'MAT_NO_GUAR_CATA': 'Not yet saved in the catalog',
        'ETI_PREG_NO_GUAR_CATA': 'Question not yet saved in the catalog',
        'MAT_CHIP_TIP': 'type',
        'MAT_TOOL_DETA_PREG': 'Question detail',
        'BTN_EDIT_PREG': 'See details',
        'MAT_TOOL_MOVE_PREG': 'Move this question',
        'BTN_EDIT_ES_PREG': 'Edit this question',
        'BTN_DELE_ES_PREG': 'Delete this question',
        'MAT_TOOL_AGRE_PREG_ARRI': 'Add question above',
        'MAT_TOOL_AGRE_PREG_ABAJ': 'Add question below',
        'MAT_LABE_SELE_VERSI_PREG': 'Select a version of the question',
        'MAT_LABE_TEX_PREG': 'Question text',
        'MAT_LABE_TEX_PREG_KEY':'Special Question Key',
        'ETI_CUE_SIG_ACC_PREG': 'Count on the following actions for this question',
        'MAT_CARD_MAES': 'Master catalog',
        'ETI_DETEC_CAMB_TEX_PREG': 'Changes were detected in the question text',
        'MAT_TOOL_YET_NO_WATER_CAT': 'Not yet saved in the catalog',
        'ETI_ESTA_PREG_NO_GUAR_CATA': 'This question is not saved in the catalog',
        'ETI_GUAR_PREG': 'Save question',
        'ETI_GUAR_CAMB': 'Save changes',
        'MAT_SLIDE_PREG_EDIT': 'Editable question',
        'MAT_SLIDE_PREG_DELET': 'Removable question',
        'MAT_SLIDE_PREG_REQUI': 'Mandatory answer',
        'ETI_AGRE_PREG': 'Add a question',
        'ETI_GRUP_PREG':'Group of Questions',
        'ETI_SECC_ESP':'Special section',
        'ETI_KEY_NO_EMPL':'Special section key not used',
        'ETI_FALT_KEY_SEC_ESP':'*Special Section Keyword missing.',
        'ETI_CLA_GRU_LIS':'Keyword:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG': 'Move question',
          'ETI_INTS_SELEC_SECC_MOVE': 'Select the group you want to move the question to',
          'ETI_NOT_PREG_MOVE1': 'NOTE:',
          'ETI_NOT_PREG_MOVE2': 'The question will be moved to the end of the selected group',
          'BTN_CANCELAR': 'Cancel',
          'ETI_CONFI_PLAN': 'Template configuration',
          'ETI_DATOS_PLAN': 'Template data:',
          'ETI_NOMB':'Name:',
          'ETI_SECC':'Groups:',
          'ETI_PREG':'Questions:',
          'ETI_NOT_CONF_CONT_SECC':'NOTE: The configuration of these controls applies to all groups and questions in the template in display mode as a business type user',
          'ETI_PERMI_SECC': 'Group permissions',
          'ETI_AGRE_SECC_NEW': 'Add new groups',
          'ETI_MOVE_SECC': 'Move groups',
          'ETI_EDIT_TITU': 'Edit title',
          'ETI_DELET_SECC': 'Delete groups',
          'ETI_NOMB_OBL_GRUP_NEW':'Mandatory names in new groups',
          'ETI_ENABLE_SEC_ESP': 'Enable special questions / sections',
          'ETI_PERMIS_PREG': 'Question permissions for each group:',
          'ETI_AGRE_PREG_NEW': 'Add new questions',
          'ETI_AGRE_PREG_CATAL': 'Add catalog questions',
          'ETI_MOVE_PREGS': 'Move questions',
          'ETI_EDIT_PREG': 'Edit questions',
          'ETI_DELET_PREG': 'Delete questions',
          'ETI_REQUIRED':'Are answers required?',
          'ETI_PREG_NEW_MAX': 'New maximum questions',
          'ETI_PREG_NEW_MAX_4ALL':'Number of practices 4All',
          'ETI_MAX_PREG_NEW': 'Maximum of new questions',
          'ETI_ENABLE_AUDIOS': 'Enable audio tracks',
          'ETI_DEMOGRAF': 'Demographics',
          'ETI_ABIER': 'Open',
          'ETI_PRAC4ALL': 'Practices 4All',
          'ETI_ADICIO': 'Additional',
          'BTN_SAL': 'Exit',
          'ETI_INST_AGRE_PREG_CAT': 'Add catalog question',
          'ETI_BUSC_SELECC_PREG_PLAN': 'In this screen you can search and select questions to add to the template',
          'ETI_VER_LIS_PREG_SELEC_3_PEST': 'You can see the list of selected questions in the third tab of this window',
          'TITULO_TAB_LIS_PREG':'List of questions',
          'TITULO_TAB_BUSC_PREG':'Search question',
          'TITULO_TAB_PREG_SELEC':'Selected questions',
          'PASO_1':'Step 1',
          'PASO_2':'Step 2',
          'ETI_SELEC_PREG_LIS_CAT': 'Select the question from the list in the catalog',
          'ETI_SELEC_PREG': 'Select a question',
          'ETI_YA_SELEC_NUM_MAX_PREG': 'You have already selected the maximum number of extra questions allowed in the template',
          'ETI_PREG_MS_UNA_VERS': 'This question has more than one version, select the one you want to view',
          'ETI_SELEC_VERS': 'Select a version',
          'ETI_PREG_SELECCIONDA': 'Selected question:',
          'ETI_AGRE_PREG': 'Add question',
          'ETI_OK_AGRE_PREG_LIST':'<b>The question has been added to the list of questions</b>, you can choose and add more questions to add to the template',
          'ETI_OK_AGRE_PREG_LIST2': 'You can also see the list of selected questions in the third tab of this window',
          'ETI_ESCR_TEXT_BUSC': 'Enter the text of the question you wish to search for',
          'ETI_BUSC_PREG_COINC': 'Searching for matching questions',
          'ETI_NO_ENCO_PREG': 'No questions were found with the text entered, try a different text',
          'ETI_RESUL_BUSC': 'Search results',
          'BTN_ELEG': 'Choose',
          'ETI_REGRE_RESUL': 'Return to results',
          'ETI_PREG_SELECC_MOMEN': 'List of questions selected so far',
          'MAT_TOOL_ELEG_VERSI': 'Choose another version',
          'MAT_TOOL_ELI_VERSI': 'Remove version',
          'BTN_REGRES': 'Return',
          'BTN_ELIG_VERSI': 'Choose version',
          'MAT_TOOL_QUITA_LIS': 'Remove from list',

          'BY_TEXT': 'By text',
          'BY_KEYWORDS': 'By keywords',
          'QUESTION_TEXT': 'Question text',
          'QUESTION_KEYWORDS': 'Keywords',
          'QUESTION_HINT': 'Keywords must start with the character <b> # </b> and be separated by commas'
        },
        'DETALLE':{
          'ETI_DETALL_PREG': 'Question detail',
          'ETI_LAB_TEX_PREG': 'Question text',
          'PLACE_HOL_TEX_PREG': 'Question text',
          'MAT_TOOL_EDIT_PREG': 'Edit this question',
          'MAT_CARD_OPC_RESP': 'Response options',
          'MAT_TOOL_EDIT_RESP': 'Edit this answer',
          'MAT_TOOL_DELET_RESP': 'Delete this answer',
          'ETI_AGRE_OPCI_RESP': 'Add an answer option',
          'ETI_SELEC_VERSI_PREG': 'Select a version of the question',
          'ETI_CUENT_SIG_ACC_PREG': 'Count on the following actions for this question',
          'ETI_DETEC_CAMB_TEXMAES': 'Master catalog',
          'ETI_CATA_MAES': 'Master catalog',
          'ETI_DETEC_CAMB_TEX_PREG': 'Changes were detected in the question text',
          'ETI_DETEC_CAMB_TEX_RESP': 'Changes in response options detected',
          'ETI_PREG_NO_GUAR_CATA': 'This question is not saved in the catalog',
          'ETI_GUAR_PREG': 'Save question',
          'ETI_GUAR_CAMB': 'Save changes',
          'ETI_BORR_PREGUN':'Delete question',
          'ETI_DELET_PREG': 'Delete question',
          'MAT_CARD_PLAN': 'Template',
          'MAT_SLIDE_PREG_EDIT': 'Editable question',
          'MAT_SLIDE_PREG_DELET': 'Removable question',
          'MAT_SLIDE_PREG_REQUI': 'Mandatory answer',
          'BTN_REGRES': 'Return',
          'ETI_NEW_PREG': 'New question',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE': 'Type the text and select the type of answer for the new question',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP': 'Write the text and add answer options for the new question',
          'ETI_TIP_PREG': 'Question type',
          'ETI_TIP_RESP': 'Response type',
          'ETI_TIP_FORM':'Question format',
          'ETI_PREG_ESP_FLD': 'Special question key',
          'ETI_PREG_ESP_HNT': 'Enter the key for the special question',
          'BTN_CANCELAR': 'Cancel',
          'BTN_CONTINU': 'Continue',
          'ETI_NEW_PRAC_4ALL': 'New 4All practice',
          'ETI_INST_NAME_DESC_4ALL': 'Enter the name and description for the new 4All practice',
          'ETI_LABE_NAME': 'Practice name',
          'ETI_LABE_DESC': 'Description of the practice',
          'ETI_CLAVE_DEMOGR': 'Write one or more keywords that identify the question, starting with the character',
          'ETI_CLAVE_DEMOGR1': 'and separated by commas',
          'ETI_CLAVE_DEMOGR2': 'NOTE: Keywords will only be stored if you save this question to the catalog when closing this window',
          'ETI_PALA_CLAVE_DEMOGR': 'Keywords',
          'ETI_SELE_TIPO_DEMOGR': 'Select the type of demographic that corresponds to the new question',

          'MAT_TOOL_CONFIG_RESP':'Configure this answer',
          'MAT_SLIDE_RESP_EDIT':'Editable answer',
          'MAT_SLIDE_RESP_DELET':'Removable answer',
          'MAT_SLIDE_RESP_TIPO_OTRO':'Type "Other"',
          'MAT_TOOL_NEWVERS_PREG':'Save as new version',
          'NOTA_PREG_MOD': 'NOTE: The text of this question has been modified, you can save it as a new version if you wish',
          'RESPUESTA_TIPO_OTRO':' - answer type "Other"',

          'TIPO_DEMOGRAFICO':'Demographic type',
          'SIN_TIPO_DEMOGRAFICO':'No demographic type selected for this question'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP': 'New template',
          'TEXT_MOD_GUA_CAM_TEMP': 'Type the name for the new template',
          'BTN_CAN_MOD_GUA_CAM_TEMP': 'Cancel',
          'BTN_AGRE_MOD_GUA_CAM_TEMP': 'Add',
          'RETUR_MOD_GUA_CAM_TEMP': 'You have not entered a text for the name',
          'SUCC_TEXT_MOD_GUA_PLAN': 'The new template was saved correctly',
          'TITU_MOD_GUA_CAM_TEMP2': 'Do you want to save the changes made to the original template? WARNING: The next time a product is assigned with this template, all the changes made so far will be included',
          'BTN_CONTI_MOD_GUA_CAM_TEMP': 'Continue',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG': 'Changes to the original template were saved correctly',
          'MENS_1': 'What kind of question do you want to add to the section?',
          'MENS_2': 'You have two options',
          'BTN_NEW': 'New',
          'BTN_D_CATA': 'From catalogue',
          'TITU_MOD_CARG_LIS_COLAB_P1': 'This file contains',
          'TITU_MOD_CARG_LIS_COLAB_P2': 'sections and a total of',
          'TITU_MOD_CARG_LIS_COLAB_P3': 'questions.WARNING: If you continue to load this file, the questions and groups you currently have will be replaced',
          'TITU_TEX_MOD_CARG_LIS_COLAB': 'You have two options',
          'BTN_AGRE_PREGU': 'Add the questions',
          'BTN_CANC_PREGU': 'Discard questions',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB': 'Questions were added correctly',
          'TEXT_MOD_NOT_CARG_LIS_COLAB': 'Questions were discarded',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB': 'The selected file has errors and cannot be loaded. Check again that all rows are placed in the correct order and try again',
          'BTN_OK': 'OK',
          'TITU_MOD_NEW_SECC': 'New section',
          'TEXT_MOD_NEW_SECC': 'Enter the name for the new section',
          'TEXT_SUCC_PREG_AGRE': 'The question was added correctly',
          'TITU_MOD_EDI_SECC': 'Modify section name',
          'TEXT_SUCC_MODIF_SECC': 'Section name changed correctly',
          'TEXT_SUCC_MODIF_GRU':'Group name was modified',
          'TITU_MOD_DELE_SECC1': 'Are you sure you want to delete this section?',
          'BTN_SI': 'Yes',
          'BTN_NO': 'No',
          'TITU_MOD_DELE_SECC2': 'This section contains one or more questions, what do you want to do with these questions',
          'BTN_DELE_PRE': 'Delete the questions',
          'BTN_CAN_TRAN': 'Transfer them to the previous section',
          'TEX_SUCC_DELE_PREG': 'The section was deleted correctly',
          'TITU_AGRE_NEW_PREG': 'New question',
          'TEXT_AGRE_NEW_PREG': 'Enter the text for the new question',
          'TITU_EDIT_PREG_MOD_PREG': 'Modify question',
          'TITU_EDIT_PREG_MOD_PRACT': 'Modify practice',
          'TITU_EDIT_PREG_MOD_DESCRI': 'Modify description',
          'TEXT_MOD_PREG_SUCC': 'The question was modified correctly',
          'TITU_2_OPCIO': 'You have two options to save this modification',
          'BTN_CONF_ACT':'Update question',
          'BTN_CANC_NEW':'As new question',
          'BTN_CONF_ACT_VERSION':'Update this version',
          'BTN_CANC_NEW_VERSION':'As new version',
          'TEX_CONFIR_MSG1': 'The question was modified correctly',
          'TEX_CONFIR_MSG2': 'Practice modified correctly',
          'TEX_CONFIR_MSG3': 'The description was modified correctly',
          'TITU_DELE_PREG': 'Are you sure you want to delete this question?',
          'TEXT_SUCC_PREG': 'The question was deleted correctly',
          'TITU_MOD_DELE_SECC_TEMPLA': 'Are you sure you want to delete this section?',
          'TITU_MOD_DELE_SECC_TEMPLA2': 'This section contains one or more questions, what do you want to do with these questions',
          'TEX_SUCC_GUAR_PREG_': 'The question was saved correctly',
          'TITU_MOD_DELE_PREG_MG': 'Are you sure you want to delete the question from the catalog? WARNING: This action cannot be reversed and the question will no longer be available in the templates that currently contain it',
          'TEX_CONFIR_MSG4_DELE': 'The question was removed from the catalog correctly',
          'TEX_GUAR_TRADU_SUCC': 'The translation was saved correctly',
          'TEX_MOVE_PREG_SECC': 'Question moved to another section',
          'TEX_SUCC__PRAC_4ALL': 'Practice was added correctly',
          'MOD_MOD_AGRE_PREG': 'The question was added to the list correctly',
          'MOD_MOD__MODIF_VERSI_PREG': 'The version of the question was changed correctly',
          'MOD_MOD__QUIT_PREG_LIST': 'The version of the question was changed correctly',
          'TITU_NUE_OPC_RESP': 'New answer option',
          'TEXT_NUE_OPC_RESP': 'Enter text for new option',
          'TEXT_NO_TEXT_PREG': 'You have not entered a text for the question',
          'TEXT_AGRE_OPC_RESP': 'Response option added correctly',
          'MOD_EDIT_RESP': 'Modify answer option',
          'MOD_EDIT_MODIF_OPC_RESP': 'The answer option was modified correctly',
          'MOD_COMFIR_DELE_OPC_RESP': 'Are you sure you want to delete this answer option?',
          'MOD_SUCC_DELE_OPC_RESP': 'The answer option was correctly deleted',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP': 'Cannot continue without adding answer options to the question',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP': 'You cannot continue without having written the text of the question first',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP': 'You cannot continue without having chosen the question type',

          'MOD_AGRE_PREG_DONDE_GUARDAR': 'Before adding the new question, do you want it to be saved to the catalog? Or do you just want to have it in this survey?',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': 'By saving it to the catalog, you can make it available to other surveys if you wish.',
          'BOT_DONDE_GUARDAR_1': 'Save it to the catalog',
          'BOT_DONDE_GUARDAR_2': 'Save it only to this survey',
          'MOD_SIN_TAGS': 'You have not yet entered at least one keyword for the question',
          'MOD_SIN_OPC_RESP': 'You have not yet entered at least two answer options for the question',
          'MOD_SIN_TIPO_DEMO': 'You have not yet selected the demographic type for this question',
          'MOD_SIN_CLA_ESPE': 'You have not yet added the key to the special question',
          'MOD_SIN_TIPO_RESP': 'You cannot continue without selecting the type of answer to the question',
          'MOD_RESP_DELOK': 'Answer option deleted successfully',
          'MOD_RESP_DELCATOK': 'The question was removed from the catalog successfully',
          'MOD_RESP_ADDTAGOK': 'Keyword added to question correctly',
          'MOD_RESP_ADDTAGERR': 'The keyword did not start with the # character',
          'MOD_RESP_DELTAGOK': 'Keyword was removed from question correctly',
          'MOD_SAVE_CAMBIOS_PREGCAT': 'When saving changes to this catalog question, the modifications made will be saved as new versions of the question texts and answer options if applicable.\n\ndo you wish to continue?',
          'MOD_SAVE_CAMB_PREGCAT': 'Where do you want to store this modification to the question text?',
          'BTN_MOD_SAVE_CAMB_PREGCAT': 'Only in this survey',
          'BTN_MOD_ACTUA_PREGCAT': 'Update the question in the catalog',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG': 'Loading',
        'TEXT_NO_ELEG_ADIC': 'No additional languages chosen',
        'ERR_MSG_TRADU': 'Translation not yet completed',
        'TEX_IDIO_PRIN': 'Main language',
        'TEX_NAM_GRUP': 'Group name',
        'TEX_TRAD_NAM': 'Enter the translation of the name',
        'TEX_NO_TRAD_TEXT': 'You have not entered the translation text',
        'TEX_TEX_PREG': 'Question text',
        'TEX_TEX_RESP': 'Response text',
        'TEX__TRA_PREG': 'Enter the translation of the question',
        'TEX__TRA_RESP': 'Enter the translation of the answer',
        'GUAR_TRA_NAM': 'Saving name translation, please wait',
        'GUAR_TRA_PRE': 'Saving question translation, please wait',
        'GUAR_TRA_RES': 'Saving translation of answer option, please wait',
        'INGR_TEX_PRAC_4ALL': 'Practice',
        'INGR_TEX_TRADU_PRAC_4ALL': 'Enter practice translation',
        'INGR_TEX_DESCR_4ALL': 'Description',
        'INGR_TEX_TRADU_DESCR_4ALL': 'Enter the translation of the description',
        'GUAR_TRADU_PRAC': 'Saving practice translation, please wait...',
        'GUAR_TRADU_DESCR': 'Saving description translation, please wait...',
      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI': 'Select a language to display the translations of the questions',
        'ETI_SIN_TRAD_PRE':'¡The translation text is missing!',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': 'Add an audio track',
          'CHANGE': 'Replace audio track'
        },
        'SUBTITULO': 'You can associate an audio track to this question through one of the following options',
        'BOTONES': {
          'RESTART': 'Back to start',
          'NEXT': 'Next',
          'BACK': 'Go back',
          'ACEPTAR': 'Accept',
          'CANCELAR': 'Cancel'
        },
        'OPCIONES': {
          'GOOGLE': 'Generate an automatic narration',
          'RECORD': 'Record a narration',
          'ARCHIVO': 'Upload an mp3 file',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': 'You can edit the text to generate automatic narration',
            'INPUT': 'Question text',
            'INPUT_TT': 'Write the question text',
            'NOTA': 'NOTE: Modifying this text will not modify the question text in the survey'
          },
          'RECORD': {
            'TITULO': 'Click the Record button to start recording audio from the microphone',
            'NOTA': 'NOTE: You may need to grant permission to use the microphone to the browser',
            'START': 'Start recording',
            'STOP': 'Recording audio, click the button to stop recording'
          },
          'ARCHIVO': {
            'INPUT': 'Click here or drag the audio file to this area to load it',
            'NOTA': 'NOTE: Only MP3 format is supported'
          },
          'PREVIEW': {
            'GENERANDO': 'Audio is generating, please wait a moment',
            'TITULO': 'Below you can listen to the loaded audio',
            'NOTA_1': 'If you want to save this audio track to the question, click the OK button',
            'NOTA_2': 'If you want to change the audio, click the Back button',
            'NOTA_3': 'If you want to change the type of audio loaded, click the Back to Start button'
          }
        },
        'MODALES': {
          'DESCARTAR': 'Are you sure to go back to the previous step? \n\n The current track will be discarded',
          'ARCHIVO_MAL': 'The uploaded file is not an audio track',
          'GUARDANDO': 'Saving audio track to question, wait a moment',
          'BORRAR': 'Are you sure to delete the audio track associated with this question',
          'CONFIRMAR_BORRAR': 'To confirm, enter the code in red in the text box: \n\n',
          'BORRADO_OK': 'The audio track of the question was deleted correctly',
          'CODIGO_MAL': 'The code entered does not match the one indicated in red',
          'AGREGANDO_PREGUNTAS': 'Selected questions are being added to the section, please wait a moment'
        },
        'PREVIOS': {
          'TITULO': 'Associated audio track',
          'SIN_AUDIO': 'There is no associated audio track',
          'SIN_AUDIO_FORALL': 'No audio track',
          'ADD_AUDIO': 'Add an audio track',
          'CON_AUDIO': 'This question has an audio track',
          'PLAY': 'Play audio',
          'CHANGE': 'Replace audio',
          'DELETE': 'Delete audio',
          'AUDIO_STATEMENT_1': 'Audio track of statement 1',
          'AUDIO_STATEMENT_2': 'Audio track of statement 2',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': 'Special section',
        'SUBTITULO_1': 'This group of questions can be established as a special section, the questions of this group will be shown only to collaborators who have the same password',
        'SUBTITULO_2': 'NOTE: It is necessary that at least one collaborator is associated with this special section in the collaborator upload step',
        'TIPOS': {
          'NORMAL': 'Normal section',
          'ESPECIAL': 'Special section'
        },
        'CAMPO': {
          'TITULO': 'Section key',
          'TOOLTIP': 'Write the key of this section',
          'HINT': 'No spaces',
          'ACEPTAR': 'Accept'
        },
        'MODALES': {
          'CONFIRM_DISABLE': 'If you disable the special sections, the question groups that are currently marked as Special sections will be converted into normal question groups, this change will apply to all question sections. \n\n Are you sure to continue?',
          'DISABLE_OK': 'All found special sections were converted to normal question groups',
          'SIN_CLAVE': 'To save the special section you need to enter a key for the section'
        }
      }
    },
  }
};
